import classNames from 'classnames';
import Icon from '../icon';
import Avatar, { AvatarProps } from './avatar';

const InactiveUserAvatar = ({ className, ...rest }: AvatarProps) => (
  <Avatar
    size={'xs'}
    {...rest}
    className={classNames('inactive-avatar', className)}
    userId={undefined}
    photo={undefined}
    markup={<Icon variant={'gray600'} name={'USER_CIRCLE'} />}
    name={undefined}
  />
);

export default InactiveUserAvatar;
